$ = jQuery;

function figureParagraph() {
  // show.bs.modal
  $(window).on('load', function() {
    if (window.innerWidth > 768) {
      var figureParagraphs = document.querySelectorAll(
        '.paragraph--type--figure');

      setTimeout(function() {
        Array.prototype.forEach.call(figureParagraphs, function(figure) {
          if (figure.children[1].children[0]) {
            if (figure.children[0].classList.contains('figure-title-container') && figure.children[1].children[0].classList.contains('field--name-field-image')) {
              if (figure.children[1].children[0].clientWidth <
                figure.children[0].clientWidth) {
                figure.children[0].style.maxWidth = figure.children[1].children[0].clientWidth +
                  'px';

                if (figure.children[1].children[1]) {
                  figure.children[1].children[1].style.maxWidth = figure.children[1].children[0].clientWidth +
                    'px';
                }
              }
            }
          }
        });
      },1000)
    }

    var modalOpenButtons = document.getElementsByClassName('modal-open-button');
    var closeButtons = document.getElementsByClassName('modal-close-button');

    Array.prototype.forEach.call(modalOpenButtons, function(resizeButton) {
      resizeButton.onclick = function() {
        if (document.getElementById(
          this.getAttribute('data-target'))) {
          document.getElementById(
            this.getAttribute('data-target')).style.display = 'block';
        }
        document.getElementsByTagName('body')[0].classList.add('disable-scroll');
      };
    });

    Array.prototype.forEach.call(closeButtons, function(closeButton) {
      closeButton.onclick = function() {
        document.getElementById(
          this.getAttribute('data-target')).style.display = 'none';
        document.getElementsByTagName('body')[0].classList.remove(
          'disable-scroll');
      };
    });

    window.onclick = function(event) {
      var modals = document.querySelectorAll(
        '.figure-modal, .signup-modal, .signup-modal-actions-container .modal-close-button');

      Array.prototype.forEach.call(modals, function(modal) {
        if (event.target == modal) {
          modal.style.display = 'none';
          document.getElementsByTagName('body')[0].classList.remove(
            'disable-scroll');

          // Check for SIGN UP modal
          if (modal.classList.contains('signup-modal') ||
            modal.classList.contains('signup-modal-close-button')) {
            setTimeout(function() {
              var popupContainer = document.getElementById(
                'sign-up-modal-popup-container');
              var globalPopupContainer = document.getElementById(
                'sign-up-modal-popup-container-global');

              if (popupContainer) {
                popupContainer.parentNode.removeChild(popupContainer);
                document.getElementById('main-wrapper').style.zIndex = 0;
              }

              if (globalPopupContainer) {
                globalPopupContainer.parentNode.removeChild(popupContainer);
                document.getElementById('main-wrapper').style.zIndex = 0;
              }
            }, 100);
          }
        }
      });
    };
  })
}
